<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1">{{data.block.conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="12" v-for="(item, index) in measures.items" :key="index">
                        <v-checkbox dense outlined :label="item.label" v-model="item.value" :disabled="preview"/>
                    </v-col>
                </v-row>
            </v-container>
    </div>
    </LayoutBlock>
</template>
<script>
import LayoutBlock from "../../../components/utils/LayoutBlock"
    
export default {
    components: {LayoutBlock},

    props: ['data','preview'],
    data(){
        return {
            measures: {
                items: [],
                result: "done"
            },
            tutorial_dialog: {
                dialog: false,
                message: "Messaggio di default"
            },
        }
    },
    methods: {
        buildMeasures(){
            if(this.data.block.conf != undefined && this.data.block.conf != null){
                for (let item of this.data.block.conf.items){
                    this.measures.items.push({label: item.label, value: false})
                }
                if(this.data.block.conf.items.length == 0){
                    console.log("$$ empty maintenance save")
                    this.saveMeasures()
                }
            }
            
        },
        saveMeasures() {
            this.$parent.$emit('updateMeasure', {b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id})
        },
        handleCloseDialog() {
            this.tutorial_dialog.dialog = false;
        },
        calcBlockResult() {
            
        }
    },
    beforeMount() {
        if(this.data.block.measures){
            this.measures = this.data.block.measures;
        } else {
            this.buildMeasures();
        }
    },

    watch: {
        measures: {
            deep: true,
            handler(){
                console.log("saved measures")
                if(!this.preview){
                    this.saveMeasures()
                }
            }
        }
    },
}
</script>